import axios from './index'

const origin = '/co/Itineraries/',
    manage = '/co/ItinerariesManage/'

const listTrips = (param) => {
    return new Promise(resolve => {
        axios.post(manage + "LoadItineraries", param).then(res => {
            resolve(res)
        })
    })
}
const loadItinerariesHistory = (param) => {
    return new Promise(resolve => {
        axios.post(manage + 'LoadItinerariesHistory', param).then(res => {
            resolve(res)
        })
    })
}

const getOrderRoutes = () => {
    return new Promise(resolve => {
        axios.post(origin + "GetAllLineNameInOrder").then(res => {
            resolve(res)
        })
    })
}

const getRouteDetail = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "GetLineDetailsInOrder", param).then(res => {
            resolve(res)
        })
    })
}

const addTrip = (param) => {
    return new Promise(resolve => {
        axios.post(origin + 'AddItineraries', param).then(res => {
            resolve(res)
        })
    })
}
const updateTrip = (param) => {
    return new Promise(resolve => {
        axios.post(origin + 'UpdateItineraries', param).then(res => {
            resolve(res)
        })
    })
}
const deleteTicket = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "DeleteItineraries", param).then(res => {
            resolve(res)
        })
    })

}
const getTripDetail = (param) => {
    return new Promise(resolve => {
        axios.post(manage + 'LoadItinerariesDetails', param).then(res => {
            resolve(res)
        })
    })
}
const selectOrder = (param) => {
    return new Promise(resolve => {
        axios.post(origin + 'selectOrder', param).then(res => {
            resolve(res)
        })
    })
}

const saveNewOrder = (param) => {
    return new Promise(resolve => {
        axios.post(origin + 'SaveNewOrder', param).then(res => {
            resolve(res)
        })
    })
}




export default {
    listTrips,
    getOrderRoutes,
    getRouteDetail,
    addTrip,
    getTripDetail,
    deleteTicket,
    updateTrip,
    selectOrder,
    saveNewOrder,
    loadItinerariesHistory
}